export const getItemTotalWeight = (obj) => {
    if (!obj || !Object.keys(obj).length) return 0;

    let totalWeight = 0;

    Object.values(obj).forEach((item) => {
        if (item.weight) {
            totalWeight += parseFloat(item.weight);
        }
    });
    return totalWeight;
};

export const getGrandTotalWeight = (weightSummary) => {
    if (!weightSummary || !Object.keys(weightSummary)) return 0;
    return Object.keys(weightSummary).reduce((total, key) => {
        return total + parseFloat(weightSummary[key]);
    }, 0);
};

export const getMainWeight = (weightSummary) => {
    if (!weightSummary || !Object.keys(weightSummary)) return 0;
    return Object.keys(weightSummary).reduce((total, key) => {
        if (key === 'size' || key === 'floors' || key === 'stair' || key === 'hoistBeam') {
            return total + parseFloat(weightSummary[key]);
        }
        return total;
    }, 0);
};
/* 샘플
const weightSummary = {
    size: 7830,
    floors: 25240,
    openings: 1364,
    hoistBeam: 655,
    cladding: 2917,
    stair: 4695,
    etc: 1121,
    fastener: 748,
    anchor: 374,
    userInput: 5000,
};
*/

export const getMainWeight1 = (weightSummary) => {
    if (!weightSummary || !Object.keys(weightSummary)) return 0;
    return Object.keys(weightSummary);
};

export const getCladdingWeight = (weightSummary) => {
    if (!weightSummary || !Object.keys(weightSummary)) return 0;
    return Object.keys(weightSummary).reduce((total, key) => {
        if (key === 'cladding' || key === 'openings') {
            return total + parseFloat(weightSummary[key]);
        }
        return total;
    }, 0);
};

export const getEtcWeight = (etc) => {
    if (!etc) return 0;
    return Object.values(etc).reduce((total, value) => {
        return total + parseFloat(value);
    }, 0);
};
